<template>
  <div class="order-submission">
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'alipay' ? 'on' : ''"
            @click="payItem('alipay')"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-zhifubao"
                :class="active === 'alipay' ? 'bounceIn' : ''"
              ></div>
              支付宝支付
            </div>
            <div class="tip">支付宝快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
          >
            <div class="name acea-row">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              现金支付
            </div>
            <div class="tip">现金方便支付</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red"
          >￥{{ orderGroupInfo.priceGroup.totalPrice }}</span
        >
      </div>
      <div class="settlement" @click="createOrder">立即结算</div>
    </div>
  </div>
</template>

<script>
import { wechatEvevt } from "@libs/wechat";
import OrderGoods from "@components/OrderGoodsSubmit";
import { cashierOrderConfirm, cashierOrderCreate } from "@api/order";
import { storeListApi } from "@api/store";
import { pay } from "@libs/wechat";
import { isPc } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
const NAME = "OrderSubmit",
  _isWeixin = this.$wechat.isWeixin(),
  _isPc = isPc();
console.log(_isPc);
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
  },
  props: {},
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function () {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    },
  },
  data: function () {
    return {
      // isAdd:false,
      iszfbshow: true,
      show2: false,
      model2: "",
      district: [],
      ready: false,
      cartid: "",
      offlinePayStatus: 2,
      yuePayStatus: 2,
      deduction: true,
      isWeixin: _isWeixin,
      active: "weixin",
      orderGroupInfo: {
        priceGroup: {},
      },
      useIntegral: false,
      mark: "",
      system_store: {},
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      storeList: {},
      auth_code: "",
      orderId: "",
    };
  },
  watch: {
    $route(n, from) {
      if (n.name === NAME) {
        this.getCartInfo();
      }
    },
  },
  mounted: function () {
    this.getCartInfo();
  },
  methods: {
    getCartInfo() {
      let data = {
        uid: this.$route.params.uid,
        cartId: this.$route.params.cartid,
      };
      cashierOrderConfirm(data)
        .then((res) => {
          this.orderGroupInfo = res.data;
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
          // this.$router.push("/");
        });
    },
    payItem: function (index) {
      this.active = index;
    },
    createOrder() {
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      // this.$dialog.loading.open("生成订单中");
      this.submit();
    },
    submit() {
      let that = this;
      // 提交订单
      cashierOrderCreate(that.orderGroupInfo.orderKey, {
        uid: that.$route.params.uid,
        payType: that.active,
        mark: that.mark || "",
      })
        .then((res) => {
          that.$dialog.loading.close();
          const data = res.data,
          url = '/user/pay_code/' + data.result.orderId + '/' + that.$route.params.uid;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              that.$dialog.toast({ mes: res.msg });
              break;
            case "SUCCESS":
              that.$dialog.success(res.msg);
              that.$router.replace(
                "/user/scan_order_details/" +
                  data.result.orderId +
                  "?uid=" +
                  that.$route.params.uid
              );
              break;
            case "WECHAT_PAY":
              that.$dialog.success(res.msg);
              that.$router.replace(url + "?code_url=" + data.result.code_url);
              break;
            case "ALIPAY_H5_PAY":
              that.$dialog.success(res.msg);
              that.$router.replace(url + "?code_url=" + data.result.code_url);
              break;
          }
        })
        .catch((err) => {
          that.$dialog.error(err.msg || "创建订单失败");
          that.$dialog.loading.close();
          // that.$router.go(-1);
        });
    },
  },
};
</script>
<style scoped>
.orderGoods {
  margin-top: 0;
}
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
.express-tips {
  color: #999;
  font-size: 0.24rem;
}
.order-submission .wrapper .item .list .payItem .name .iconfont {
  margin-left: 0.6rem;
}
.order-submission .wrapper .item .list .payItem .name .icon-zhifubao {
  background-color: #027aff;
}
</style>